import { useLogoutFlow } from 'modules/auth/flows/useLogoutFlow'
import { useSendVerificationEmailFlow } from 'modules/auth/flows/useSendVerificationEmailFlow'
import { Illustration } from 'modules/common/components/Illustrations/Illustration'
import { Seo } from 'modules/common/components/Seo/Seo'
import { IconArrowLeft } from 'modules/common/components/_icons/icons'
import LayoutLogin from 'modules/common/components/_layouts/LayoutLogin'
import { Button } from 'modules/common/components/_ui/Button/Button'
import { useTranslation } from 'modules/common/hooks/useTranslation'
import { EnumRoutes } from 'modules/common/routes'
import { BlankPage } from 'modules/common/types/page'
import { Trans } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

const EmailVerification: BlankPage = () => {
  const { t } = useTranslation('auth-page-email-verification')
  const { logout, loading: isLogoutLoading } = useLogoutFlow({
    redirectTo: EnumRoutes.LOGIN,
  })

  const { isLoading, resendEmail, user } = useSendVerificationEmailFlow()

  return (
    <>
      <Seo
        title={t('meta.title')}
        description={t('meta.description')}
        noindex
      />

      <Illustration name="mail" size="l" />
      <div className="flex max-w-xs flex-col items-center">
        <h2 className="py-4 text-center">{t('h1')}</h2>
        <p className="pb-4 text-center text-info-600">{t('description')}</p>
        <p className="pb-14 text-center text-sm text-info-400">
          {t('recommendation')}
        </p>
        <Button
          variant="primary"
          color="default"
          onClick={resendEmail}
          isLoading={isLoading}
          disabled={user?.emailVerified}
          className="mb-4 self-stretch"
          type="submit"
        >
          {t('sendEmailButton')}
        </Button>
        <Button
          variant="secondary"
          color="default"
          className="items-center justify-center self-stretch"
          onClick={logout}
          isLoading={isLogoutLoading}
          icon={
            <IconArrowLeft className="inline translate-x-1 transition-transform" />
          }
        >
          <Trans parent="p">{t('backButton')}</Trans>
        </Button>
      </div>
    </>
  )
}

export const getStaticProps = async ({ locale }: { locale: string }) => ({
  props: {
    ...(await serverSideTranslations(locale, [
      'auth-page-email-verification',
      'auth-components',
      'common',
      'common-components',
    ])),
  },
})

EmailVerification.getLayout = (page) => <LayoutLogin>{page}</LayoutLogin>
EmailVerification.type = 'authenticated'

export default EmailVerification
